export default "__VITE_ASSET__CUCIzcD7__"